import { render, staticRenderFns } from "./PageEducatorInstitutionAdd.vue?vue&type=template&id=6e7f1d5f&scoped=true&"
import script from "./PageEducatorInstitutionAdd.vue?vue&type=script&lang=js&"
export * from "./PageEducatorInstitutionAdd.vue?vue&type=script&lang=js&"
import style0 from "./PageEducatorInstitutionAdd.vue?vue&type=style&index=0&id=6e7f1d5f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e7f1d5f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VBtn,VCard,VCardTitle,VContainer,VDivider,VForm})
